import { InvoiceDocumentType } from '../enums/invoiceDocumentType'

export const isDocumentTypeCreditNote = (documentType?: InvoiceDocumentType): boolean =>
  documentType?.toLowerCase() === InvoiceDocumentType.CreditNote
